<div class="card shadow-sm">
    <div class="card-header">
        <h3 class="card-title">Other</h3>
    </div>
    <div class="card-body">
        <form [formGroup]="form">
            <div class="row d-flex flex-column">
                <div class="col-12mt-2">
                    <proposals-attachments-panel
                        label="Other Agreement"
                        [proposal]="proposal"
                        [attachments]="otherAgreements"
                        [readonlyAttachmentsPanel]="readonlyProposalsForm" />
                </div>

            </div>
        </form>
    </div>
</div>